import { motion } from "framer-motion";

const ease = [0.2, 0.7, 0.2, 1];

export function Reveal({ children, delay = 0, y = 28, className = "", as = "div" }) {
  const M = motion[as] || motion.div;
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.9, delay, ease }}
    >
      {children}
    </M>
  );
}

export function MaskLines({ lines, className = "", delay = 0.2, as = "h1", lineClass = "" }) {
  const Tag = as;
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]">
          <motion.span
            className={`block ${lineClass}`}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.15, delay: delay + i * 0.14, ease }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}

export function SectionLabel({ index, children, light = false }) {
  return (
    <div className={`eyebrow flex items-center gap-4 ${light ? "text-stone" : "text-forest"}`}>
      {index && <span className="font-serif text-base italic tracking-normal normal-case">{index}</span>}
      <span className={`h-px w-10 ${light ? "bg-stone/60" : "bg-forest/40"}`} />
      <span>{children}</span>
    </div>
  );
}
